import React from "react"
import { Container, Image, Text } from "@mantine/core"
import { useStyles } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/FavoritesRecentsTabs.styles"
import { UnstyledButton, Icon, Button } from "@/components"
import { EmptyTab } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/EmptyTab"
import type { FavoritesTabProps } from "@/components/TopNavigation/types"

import { handleSegueSearch } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/helpers"

export const FavoritesTab = (props: FavoritesTabProps) => {
    const ALLOWED_ACTION_TYPES: number[] = [
        DjangIO.app.useractions.types.UserActionType.search_created.value,
        //  Legacy favorites tab includes special logic for child user action types (ex. DjangIO.app.useractions.types.UserActionType.profile_visited_person) and we only want the parent (ex. DjangIO.app.useractions.types.UserActionType.profile_visited)
        DjangIO.app.useractions.types.UserActionType.profile_visited.value,
        // children
        DjangIO.app.useractions.types.UserActionType.profile_visited_person.value,
        DjangIO.app.useractions.types.UserActionType.profile_visited_bill.value,
        DjangIO.app.useractions.types.UserActionType.profile_visited_campaign.value,
        DjangIO.app.useractions.types.UserActionType.profile_visited_issue.value,
        DjangIO.app.useractions.types.UserActionType.profile_visited_issue_management.value,
        DjangIO.app.useractions.types.UserActionType.profile_visited_media_article.value,
        DjangIO.app.useractions.types.UserActionType.outbox_details_page_visited.value,
    ]

    const { classes } = useStyles()

    const { favorites, unfavoriteUserAction, closeSearchPopdown, segueToSearch, segueToProfile, setSearchTerm } = props
    return (
        <Container className={classes.container}>
            {favorites.length > 0 ? (
                <>
                    {favorites
                        .filter((favorite) => {
                            return ALLOWED_ACTION_TYPES.includes(favorite.action_type)
                        })
                        .map((favorite) => {
                            const dataType: any = DjangIO.app.models.QuorumDataType.by_value(favorite.data_type)
                            const displayImage = favorite.person__image_url || favorite.supporter__image_url

                            return (
                                <div className={classes.itemContainer} key={favorite.id}>
                                    <UnstyledButton
                                        className={classes.button}
                                        onClick={() =>
                                            handleSegueSearch(
                                                favorite,
                                                dataType,
                                                setSearchTerm,
                                                segueToProfile,
                                                segueToSearch,
                                                closeSearchPopdown,
                                            )
                                        }
                                    >
                                        <div className={classes.iconContainer}>
                                            {displayImage === null ? (
                                                <Icon
                                                    icon={dataType.fa5_icon}
                                                    iconFamily={dataType.fa5_icon_family || "fas"}
                                                />
                                            ) : (
                                                <Image height="2rem" fit="cover" radius="50%" src={displayImage} />
                                            )}
                                        </div>

                                        <div className={classes.searchText}>
                                            <Text className={classes.text}>{favorite.humanized_text}</Text>
                                        </div>

                                        <div className={classes.dataTypeText}>
                                            <Text>{dataType.singular}</Text>
                                        </div>
                                    </UnstyledButton>

                                    <div className={classes.actionsContainer}>
                                        <Button
                                            className={classes.actionIcon}
                                            variant="transparent"
                                            aria-label="Unfavorite"
                                            onClick={() => {
                                                unfavoriteUserAction(favorite)
                                            }}
                                        >
                                            <Icon icon="star" className={classes.starIcon} iconFamily="fas" />
                                        </Button>
                                    </div>
                                </div>
                            )
                        })}
                    {favorites.length > 7 && (
                        <div className={classes.noMoreResultsText}>
                            <Icon icon="exclamation-circle" />
                            No more results
                        </div>
                    )}
                </>
            ) : (
                <EmptyTab
                    icon="star"
                    title="No Favorites found"
                    description="Click the star icon in the search bar to save a search. After favoriting a search, you can see it here and quickly revisit that search."
                />
            )}
        </Container>
    )
}
